import React from 'react';
import {Card, Tag} from 'oui-react';
import bandwidthStore from '../store/bandwidth';

const WorkLoadType = (props) => {
  
  const onClickHandler = () => {
    bandwidthStore.reset();
    bandwidthStore.hide();
    bandwidthStore.selectCategory(props.id);
    bandwidthStore.showSubmitButton();
    props.onClick(props.id);
  }
  
  return (
    <div className="col-xs-3 oui-showcase-cards oui-inline" >
      <Card className={`oui-info-card ${props.id.includes(props.state.category) ? 'activeCard': ''}`}onClick={onClickHandler}>
        <div>
          <h4>{props.title}</h4>
          <hr className="cardDivider"></hr>
          <div className="savingsLabel">Estimated Savings</div>
          <div className="savings">{props.savings}</div>
          <div className="tags">
          {props.tag1 &&
            <Tag color={props.tagColor}>{props.tag1}</Tag>
          }
          {props.tag2 &&
            <Tag color={props.tagColor}>{props.tag2}</Tag>
          }
          {props.tag3 &&
          <Tag color={props.tagColor}>{props.tag3}</Tag>
          }
          </div>
          <p className="body2">{props.info}</p>
        </div>
      </Card>
    </div>
  )
};

export default WorkLoadType;
